export default __webpack_public_path__ + "static/doc/documentationUtilisateurNotice.701ee45.pdf";